/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { ReferencingObjectDto } from './ReferencingObjectDto';
import {
    ReferencingObjectDtoFromJSON,
    ReferencingObjectDtoFromJSONTyped,
    ReferencingObjectDtoToJSON,
} from './ReferencingObjectDto';
import type { TaskItemAreaDtoTaskTypeData } from './TaskItemAreaDtoTaskTypeData';
import {
    TaskItemAreaDtoTaskTypeDataFromJSON,
    TaskItemAreaDtoTaskTypeDataFromJSONTyped,
    TaskItemAreaDtoTaskTypeDataToJSON,
} from './TaskItemAreaDtoTaskTypeData';
import type { EvaluationParameterScopeDto } from './EvaluationParameterScopeDto';
import {
    EvaluationParameterScopeDtoFromJSON,
    EvaluationParameterScopeDtoFromJSONTyped,
    EvaluationParameterScopeDtoToJSON,
} from './EvaluationParameterScopeDto';
import type { MedicalSystemSetupBaseDto } from './MedicalSystemSetupBaseDto';
import {
    MedicalSystemSetupBaseDtoFromJSON,
    MedicalSystemSetupBaseDtoFromJSONTyped,
    MedicalSystemSetupBaseDtoToJSON,
} from './MedicalSystemSetupBaseDto';
import type { TaskItemAreaDtoInstruction } from './TaskItemAreaDtoInstruction';
import {
    TaskItemAreaDtoInstructionFromJSON,
    TaskItemAreaDtoInstructionFromJSONTyped,
    TaskItemAreaDtoInstructionToJSON,
} from './TaskItemAreaDtoInstruction';
import type { TaskItemQaEquipmentSetupDto } from './TaskItemQaEquipmentSetupDto';
import {
    TaskItemQaEquipmentSetupDtoFromJSON,
    TaskItemQaEquipmentSetupDtoFromJSONTyped,
    TaskItemQaEquipmentSetupDtoToJSON,
} from './TaskItemQaEquipmentSetupDto';
import type { TaskItemAreaDtoCombinationTable } from './TaskItemAreaDtoCombinationTable';
import {
    TaskItemAreaDtoCombinationTableFromJSON,
    TaskItemAreaDtoCombinationTableFromJSONTyped,
    TaskItemAreaDtoCombinationTableToJSON,
} from './TaskItemAreaDtoCombinationTable';

/**
 * 
 * @export
 * @interface TaskItemAreaDto
 */
export interface TaskItemAreaDto {
    /**
     * 
     * @type {string}
     * @memberof TaskItemAreaDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TaskItemAreaDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof TaskItemAreaDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TaskItemAreaDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TaskItemAreaDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskItemAreaDto
     */
    readonly isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TaskItemAreaDto
     */
    readonly deleterUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TaskItemAreaDto
     */
    readonly deletionTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskItemAreaDto
     */
    name?: string | null;
    /**
     * 
     * @type {MedicalSystemSetupBaseDto}
     * @memberof TaskItemAreaDto
     */
    medicalSystemSetup?: MedicalSystemSetupBaseDto;
    /**
     * 
     * @type {Array<TaskItemQaEquipmentSetupDto>}
     * @memberof TaskItemAreaDto
     */
    qaEquipmentSetups?: Array<TaskItemQaEquipmentSetupDto> | null;
    /**
     * 
     * @type {TaskItemAreaDtoInstruction}
     * @memberof TaskItemAreaDto
     */
    instruction?: TaskItemAreaDtoInstruction | null;
    /**
     * 
     * @type {TaskItemAreaDtoTaskTypeData}
     * @memberof TaskItemAreaDto
     */
    taskTypeData?: TaskItemAreaDtoTaskTypeData | null;
    /**
     * 
     * @type {TaskItemAreaDtoCombinationTable}
     * @memberof TaskItemAreaDto
     */
    combinationTable?: TaskItemAreaDtoCombinationTable | null;
    /**
     * 
     * @type {Array<EvaluationParameterScopeDto>}
     * @memberof TaskItemAreaDto
     */
    evaluationScopes?: Array<EvaluationParameterScopeDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskItemAreaDto
     */
    isReferenced?: boolean;
    /**
     * 
     * @type {Array<ReferencingObjectDto>}
     * @memberof TaskItemAreaDto
     */
    isReferencedBy?: Array<ReferencingObjectDto> | null;
    /**
     * 
     * @type {string}
     * @memberof TaskItemAreaDto
     */
    $type?: TaskItemAreaDtoTypeEnum;
}


/**
 * @export
 */
export const TaskItemAreaDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoTaskItemAreaDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.TaskItemAreaDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TaskItemAreaDtoTypeEnum = typeof TaskItemAreaDtoTypeEnum[keyof typeof TaskItemAreaDtoTypeEnum];



/**
 * Check if a given object implements the TaskItemAreaDto interface.
 */
export function instanceOfTaskItemAreaDto(value?: unknown): value is TaskItemAreaDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TaskItemAreaDtoTypeEnum)[0];
}

export function TaskItemAreaDtoFromJSON(json: any): TaskItemAreaDto {
    return TaskItemAreaDtoFromJSONTyped(json, false);
}

export function TaskItemAreaDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskItemAreaDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'isDeleted': json['isDeleted'] == null ? undefined : json['isDeleted'],
        'deleterUserId': json['deleterUserId'] == null ? undefined : json['deleterUserId'],
        'deletionTime': json['deletionTime'] == null ? undefined : json['deletionTime'],
        'name': json['name'] == null ? undefined : json['name'],
        'medicalSystemSetup': json['medicalSystemSetup'] == null ? undefined : MedicalSystemSetupBaseDtoFromJSON(json['medicalSystemSetup']),
        'qaEquipmentSetups': json['qaEquipmentSetups'] == null ? undefined : ((json['qaEquipmentSetups'] as Array<any>).map(TaskItemQaEquipmentSetupDtoFromJSON)),
        'instruction': json['instruction'] == null ? undefined : TaskItemAreaDtoInstructionFromJSON(json['instruction']),
        'taskTypeData': json['taskTypeData'] == null ? undefined : TaskItemAreaDtoTaskTypeDataFromJSON(json['taskTypeData']),
        'combinationTable': json['combinationTable'] == null ? undefined : TaskItemAreaDtoCombinationTableFromJSON(json['combinationTable']),
        'evaluationScopes': json['evaluationScopes'] == null ? undefined : ((json['evaluationScopes'] as Array<any>).map(EvaluationParameterScopeDtoFromJSON)),
        'isReferenced': json['isReferenced'] == null ? undefined : json['isReferenced'],
        'isReferencedBy': json['isReferencedBy'] == null ? undefined : ((json['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TaskItemAreaDtoToJSON(value?: Omit<TaskItemAreaDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'|'isDeleted'|'deleterUserId'|'deletionTime'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'name': value['name'],
        'medicalSystemSetup': MedicalSystemSetupBaseDtoToJSON(value['medicalSystemSetup']),
        'qaEquipmentSetups': value['qaEquipmentSetups'] == null ? undefined : ((value['qaEquipmentSetups'] as Array<any>).map(TaskItemQaEquipmentSetupDtoToJSON)),
        'instruction': TaskItemAreaDtoInstructionToJSON(value['instruction']),
        'taskTypeData': TaskItemAreaDtoTaskTypeDataToJSON(value['taskTypeData']),
        'combinationTable': TaskItemAreaDtoCombinationTableToJSON(value['combinationTable']),
        'evaluationScopes': value['evaluationScopes'] == null ? undefined : ((value['evaluationScopes'] as Array<any>).map(EvaluationParameterScopeDtoToJSON)),
        'isReferenced': value['isReferenced'],
        'isReferencedBy': value['isReferencedBy'] == null ? undefined : ((value['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoToJSON)),
        '$type': value['$type'],
    });
}

